export type languageItem = {
  id: number;
  key: string;
  value: string;
};

export class LanguagePackage {
  languageId: number;
  itemsArray: languageItem[];
  displayName: string;

  constructor() {
    this.languageId = -1;
    this.itemsArray = [];
    this.displayName = "";
  }
}
